import { Query } from '../../../_base/actionBus/Query';
import { LocalDate } from '../../../_base/time/LocalDate';

export class GetAvailableBookingDays extends Query<LocalDate[]> {
    constructor(public amenityId: number) {
        super();
    }
}
